module.exports = __webpack_public_path__ + "static/media/cenitlogo.0c31e981.png";